/**
 * Centered-logo desktop:
 * - Non-index (--sticky): wrapper is static; when #AccessibleNav would leave the viewport,
 *   pin it with position:fixed + placeholder.
 * - Index (--index, fixed hero header): wrapper stays fixed; after scroll past hero + logo row,
 *   add .ak-index-nav-only on the wrapper so only the nav bar stays visible (logo collapses).
 */
(function () {
  var wrapper = document.getElementById('header-scroll-wrapper');
  if (!wrapper) return;

  var nav = document.getElementById('AccessibleNav');
  var header = wrapper.querySelector('header.site-header.logo--center');
  var headerSection = document.querySelector('[data-header-section]');
  if (!nav || !header || !headerSection) return;
  if (!headerSection.contains(nav)) return;
  var afterHeader = header.nextElementSibling;
  if (afterHeader === nav) {
    /* header → nav */
  } else if (
    afterHeader &&
    afterHeader.classList.contains('site-header__desktop-search-slot') &&
    afterHeader.nextElementSibling === nav
  ) {
    /* header → desktop search → nav */
  } else {
    return;
  }

  var isStickyTemplate = wrapper.classList.contains('header-scroll-wrapper--sticky');
  var isIndexTemplate =
    wrapper.classList.contains('header-scroll-wrapper--index') &&
    !isStickyTemplate;
  if (!isStickyTemplate && !isIndexTemplate) return;

  var mq = window.matchMedia('(min-width: 750px)');

  if (isStickyTemplate) {
    var FIXED = 'nav-is-bar-fixed';
    var navDocTop = 0;
    var placeholder = null;

    function measureNavDocTop() {
      if (nav.classList.contains(FIXED)) return;
      var r = nav.getBoundingClientRect();
      navDocTop = r.top + window.pageYOffset;
    }

    function ensurePlaceholder() {
      if (placeholder) return;
      placeholder = document.createElement('div');
      placeholder.id = 'ak-nav-sticky-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.style.cssText =
        'display:none;flex-shrink:0;width:100%;margin:0;padding:0;border:0;';
      nav.parentNode.insertBefore(placeholder, nav.nextSibling);
    }

    function syncPlaceholderHeight() {
      if (!placeholder || !nav.classList.contains(FIXED)) return;
      var h = nav.offsetHeight;
      placeholder.style.height = h + 'px';
      placeholder.style.display = h ? 'block' : 'none';
    }

    function setFixed(on) {
      if (on) {
        if (!nav.classList.contains(FIXED)) {
          ensurePlaceholder();
          syncPlaceholderHeight();
          nav.classList.add(FIXED);
        } else {
          syncPlaceholderHeight();
        }
      } else {
        nav.classList.remove(FIXED);
        if (placeholder) {
          placeholder.style.display = 'none';
          placeholder.style.height = '0';
        }
      }
    }

    function tick() {
      if (!mq.matches) {
        setFixed(false);
        return;
      }

      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y + 0.5 >= navDocTop) {
        setFixed(true);
      } else {
        setFixed(false);
        measureNavDocTop();
      }
    }

    function onScroll() {
      window.requestAnimationFrame(tick);
    }

    function onResize() {
      setFixed(false);
      measureNavDocTop();
      tick();
    }

    measureNavDocTop();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    if (mq.addEventListener) mq.addEventListener('change', onResize);
    else if (mq.addListener) mq.addListener(onResize);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        measureNavDocTop();
        tick();
      });
    }
    window.addEventListener('load', function () {
      measureNavDocTop();
      tick();
    });

    tick();
    return;
  }

  /* Index: collapse logo inside fixed header after same scroll distance as “logo scrolled away” */
  var NAV_ONLY = 'ak-index-nav-only';
  var cachedHeadH = 80;

  function refreshHeadCache() {
    if (!mq.matches || !header) return;
    var had = wrapper.classList.contains(NAV_ONLY);
    if (had) wrapper.classList.remove(NAV_ONLY);
    cachedHeadH = Math.max(header.offsetHeight || 0, 72);
    if (had) wrapper.classList.add(NAV_ONLY);
  }

  function tickIndex() {
    if (!mq.matches) {
      wrapper.classList.remove(NAV_ONLY);
      return;
    }

    if (wrapper.classList.contains('header-scroll-wrapper--hidden')) {
      wrapper.classList.remove(NAV_ONLY);
      return;
    }

    if (!wrapper.classList.contains(NAV_ONLY) && header && header.offsetHeight > 0) {
      cachedHeadH = Math.max(header.offsetHeight, 72);
    }

    var hero = document.getElementById('shopify-section-hero-video-section');
    var heroH = hero ? hero.offsetHeight || 0 : 0;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var threshold = heroH > 0 ? heroH + cachedHeadH : cachedHeadH;

    if (y + 0.5 >= threshold) {
      wrapper.classList.add(NAV_ONLY);
    } else {
      wrapper.classList.remove(NAV_ONLY);
    }
  }

  function onScrollIndex() {
    window.requestAnimationFrame(tickIndex);
  }

  function onResizeIndex() {
    refreshHeadCache();
    tickIndex();
  }

  refreshHeadCache();
  window.addEventListener('scroll', onScrollIndex, { passive: true });
  window.addEventListener('resize', onResizeIndex);
  if (mq.addEventListener) mq.addEventListener('change', onResizeIndex);
  else if (mq.addListener) mq.addListener(onResizeIndex);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      refreshHeadCache();
      tickIndex();
    });
  }
  window.addEventListener('load', function () {
    refreshHeadCache();
    tickIndex();
  });

  tickIndex();
})();

